(function ($) { 

  Drupal.behaviors.homeTeaserVirtualMuseum = {
	    attach: function (context) {
	    		Drupal.behaviors.homeTeaserVirtualMuseumCreator(context);
	    }
  };
  
  Drupal.behaviors.homeTeaserVirtualMuseumCreator = function (context){
		$(".homeTeaserVirtualMuseum", context).each(function (index){    			
			var mainContent = $(this);
			var footerNavText = $(mainContent).data("footer-nav");
			var images = $(mainContent).data("images");
			
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	$(mainContent).height($(window).height());
	    	Drupal.behaviors.linkButtonCreator($(mainContent));
	    	
  		$(".homeTeaserMain",mainContent).addClass("main-content-offset fullHeight position-relative");
  		$(".homeTeaserTextMain",mainContent).addClass("fullHeight");
  		$(".homeTeaserImageWrapper",mainContent).addClass("row fullHeight fullWidth");
  		$(".homeTeaserImageWrapper",mainContent).append('<div class="homeTeaserMainImageMask position-relative fullHeight ">\
  				<div class="homeTeaserVirtualMuseumImagesArea position-absolute margin-auto"></div></div>');
  		$.each(images, function(index){
	    		$(".homeTeaserVirtualMuseumImagesArea",mainContent).append('\
	    				<div class="homeTeaserVirtualMuseumImageRect' + (index + 1) + ' homeTeaserVirtualMuseumImage" style="background-image:url(' + images[index].imagePath + ')"></div>');
	    		
	    		$(mainContent).append('<div class="animatedImage' + (index + 1) + '  homeTeaserVirtualMuseumAnimatedImage reveal-animate" style="\
	    				background-image:url(' + images[index].imagePath + ');\
	    		"></div>');
	    		
  		})
  		
		Drupal.behaviors.calcHomeTeaserVirtualMuseum(mainContent);
		  
		//And Everytime the user resizes the window
		$(window).resize(function() {
			$(mainContent).height($(window).height());
			Drupal.behaviors.calcHomeTeaserVirtualMuseum(mainContent);
		});

		$(mainContent).addClass("overflow-hidden");
		/*
		$(mainContent).data("animation-type","AboveToCenter");
		Drupal.behaviors.homeTeaserVirtualMuseumScroll();
		*/
		$(mainContent).data("saph-done",true);

		$(mainContent).ready(function(){
			//Drupal.behaviors.functions.initOnScreenAnimations(".homeTeaserVirtualMuseum");
  		});
  	});
  }  
  
	Drupal.behaviors.calcHomeTeaserVirtualMuseum = function (mainContent) {
		var fullHeight = $(mainContent).height();
		var fullWidth = $(mainContent).width();
		var textSectionHeight = $(".homeTeaserVirtualMuseumTextSection",mainContent).height();
		var textSectionTop;
		var bottomPositionLimit;
		var saphNavHeaderHeight = Drupal.behaviors.maxHeightOfNavBar();//$(".saphNavHeader").first().height();
		var imageSectionWidth = $(".homeTeaserMainImageMask",mainContent).width();
		var imageCol1Width = $(".homeTeaserVirtualMuseumImageCol2",mainContent).width();
		var textPortraitBottomOffset = 64;
		var textSectionHeight;
		
		Drupal.behaviors.functions.consolog("Drupal.behaviors.calcHomeTeaserVirtualMuseum()");

		//$(".homeTeaserVirtualMuseumTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
		//textSectionTop = $(".homeTeaserVirtualMuseumTextSection",mainContent).position().top;
		//textSectionTop = $(".homeTeaserVirtualMuseumTextSection",mainContent).position().top;
		
		$(".homeTeaserVirtualMuseumImagesArea",mainContent).css("top",0);
		$(".homeTeaserVirtualMuseumImagesArea",mainContent).css("bottom",64);
		$(".homeTeaserVirtualMuseumImagesArea",mainContent).css("left",0);
		$(".homeTeaserVirtualMuseumImagesArea",mainContent).css("right",0);
		
		var actualHeight;
		
		if(Drupal.behaviors.isPortraitMode()){
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).addClass("h3");
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).removeClass("h2");
				
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("text-class","h2");	
				
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).addClass("h2");
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).removeClass("h1-hero");
			}else{
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).addClass("h2");
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).removeClass("h3");

				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("text-class","h1-hero");	
				
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).removeClass("h2");
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).addClass("h1-hero");
			}
			if($(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).length){
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-10 col-xs-offset-2");
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-12");
			
			$(".homeTeaserVirtualMuseumSubHeadline",mainContent).addClass("col-xs-12");
			$(".homeTeaserVirtualMuseumSubHeadline",mainContent).removeClass("col-xs-5");
			
			$(".homeTeaserVirtualMuseumHeadline",mainContent).addClass("col-xs-12");
			$(".homeTeaserVirtualMuseumHeadline",mainContent).removeClass("col-xs-5");
			
			textSectionHeight = $(".homeTeaserVirtualMuseumTextSection",mainContent).height();	
			$(".homeTeaserVirtualMuseumTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
			textSectionTop = $(".homeTeaserVirtualMuseumTextSection",mainContent).position().top;
			actualHeight = textSectionTop-saphNavHeaderHeight-30;
		}else{
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).addClass("h3");
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).removeClass("h2");
				
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("text-class","h2");	
				
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).addClass("h2");
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).removeClass("h1-hero");				
			}else{
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).addClass("h2");
				$(".homeTeaserVirtualMuseumSubHeadline span",mainContent).removeClass("h3");

				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("text-class","h1-hero");		
				
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).removeClass("h2");
				$(".homeTeaserVirtualMuseumHeadline span",mainContent).addClass("h1-hero");
			}
			if($(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).length){
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserVirtualMuseumHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-10 col-xs-offset-2");
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-12");
			
			$(".homeTeaserVirtualMuseumSubHeadline",mainContent).removeClass("col-xs-12");
			$(".homeTeaserVirtualMuseumSubHeadline",mainContent).addClass("col-xs-5");
			
			$(".homeTeaserVirtualMuseumHeadline",mainContent).removeClass("col-xs-12");
			$(".homeTeaserVirtualMuseumHeadline",mainContent).addClass("col-xs-5");
			
			textSectionHeight = $(".homeTeaserVirtualMuseumTextSection",mainContent).height();	
			$(".homeTeaserVirtualMuseumTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
			textSectionTop = $(".homeTeaserVirtualMuseumTextSection",mainContent).position().top;
			actualHeight = fullHeight-saphNavHeaderHeight-30;
		}
		
		/*
		if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld" ){
			actualHeight = textSectionTop-saphNavHeaderHeight-30;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}else{
			actualHeight = fullHeight-saphNavHeaderHeight-30;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}
		*/
		$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		$(".homeTeaserMainImageMask",mainContent).css("top",saphNavHeaderHeight + 30);
		
		//Default size
		/*
		 * Window
		 * width 1005
		 * height 888
		 */
		
		var ratioW = $(".homeTeaserMainImageMask",mainContent).width()/1005;
		var ratioH = actualHeight/888;
		var actualRatio = ratioH;
		if(ratioW<ratioH){
			actualRatio = ratioW;
		}
		    
		$(".homeTeaserVirtualMuseumImageRect1",mainContent).css("left",0*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect1",mainContent).css("top",111.15*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect1",mainContent).css("width",478.59*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect1",mainContent).css("height",319.27*actualRatio);

		$(".homeTeaserVirtualMuseumImageRect2",mainContent).css("left",620.57*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect2",mainContent).css("top",0*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect2",mainContent).css("width",384.14*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect2",mainContent).css("height",512.17*actualRatio);

		$(".homeTeaserVirtualMuseumImageRect3",mainContent).css("left",312.41*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect3",mainContent).css("top",178.78*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect3",mainContent).css("width",356.72*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect3",mainContent).css("height",268.28*actualRatio);

		$(".homeTeaserVirtualMuseumImageRect4",mainContent).css("left",108.37*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect4",mainContent).css("top",378.63*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect4",mainContent).css("width",313.52*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect4",mainContent).css("height",358.08*actualRatio);

		$(".homeTeaserVirtualMuseumImageRect5",mainContent).css("left",354.77*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect5",mainContent).css("top",333.02*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect5",mainContent).css("width",273*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect5",mainContent).css("height",303*actualRatio);

		$(".homeTeaserVirtualMuseumImageRect6",mainContent).css("left",554.4*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect6",mainContent).css("top",465.84*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect6",mainContent).css("width",229.32*actualRatio);
		$(".homeTeaserVirtualMuseumImageRect6",mainContent).css("height",333.69*actualRatio);
		
		$(".homeTeaserVirtualMuseumImagesArea",mainContent).width((620.57*actualRatio) + (384.14*actualRatio));
		$(".homeTeaserVirtualMuseumImagesArea",mainContent).height((553.84*actualRatio) + (333.69*actualRatio));
		
		//Setup the animatedImages pos and size
		var images = $(mainContent).data("images");
		var positionOfMainContainer = $(mainContent).offset();
		$.each(images, function(index){
			$(".animatedImage" + (index + 1),mainContent).css("left", $(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent).offset().left - positionOfMainContainer.left);
			$(".animatedImage" + (index + 1),mainContent).css("top", $(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent).offset().top - positionOfMainContainer.top);
			$(".animatedImage" + (index + 1),mainContent).width($(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent).width());
			$(".animatedImage" + (index + 1),mainContent).height($(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent).height());
			$(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent).addClass("dissappearElement");
		});
		$(mainContent).append($(".homeTeaserMain",mainContent));
	};  
  
  
	Drupal.behaviors.changeHomeTeaserVirtualMuseumMode = function () {
		$(".homeTeaserVirtualMuseum").each(function (index){
			var mainContent = $(this);
			$(mainContent).height($(window).height());
			Drupal.behaviors.calcHomeTeaserVirtualMuseum(mainContent);
    		});
	};
	
	Drupal.behaviors.animateHomeTeaserVirtualMuseumAboveToCenter = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();
			
			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "AboveToCenter" || currentAnimationType == "BelowToCenter"){
				return true;
			}
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserVirtualMuseumAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			
	    			$(animatedImageElement).animate({
						top: -$(animatedImageElement).height(),
					    visibility: "hidden",
					    opacity: 0
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
							  visibility: "visible",
							  opacity: opacityUsed
						  }, animationTime, function() {
						    // Animation complete.
						  });
					  });
			});
    		//});
	};
	Drupal.behaviors.animateHomeTeaserVirtualMuseumCenterToAbove = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();
		
			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "CenterToBelow" || currentAnimationType == "CenterToAbove"){
				return true;
			}
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserVirtualMuseumAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
	    					top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
					    visibility: "visible",
					    opacity: opacityUsed
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: -$(animatedImageElement).height(),
							  visibility: "hidden",
							  opacity: 0
						  }, animationTime, function() {
						    // Animation complete.

						  });
					  });
			});
    		//});
	};	
	
	Drupal.behaviors.animateHomeTeaserVirtualMuseumBelowToCenter = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "AboveToCenter" || currentAnimationType == "BelowToCenter"){
				return true;
			}
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserVirtualMuseumAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
						top: $(mainContent).height(),
					    visibility: "hidden",
					    opacity: 0
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
							  visibility: "visible",
							  opacity: opacityUsed
						  }, animationTime, function() {
						    // Animation complete.

						  });
					  });
			});
    		//});
	};	

	Drupal.behaviors.animateHomeTeaserVirtualMuseumCenterToBelow = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "CenterToBelow" || currentAnimationType == "CenterToAbove"){
				return true;
			}
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserVirtualMuseumAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserVirtualMuseumImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
	    					top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
					    visibility: "visible",
					    opacity: opacityUsed
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(mainContent).height(),
							  visibility: "hidden",
							  opacity: 0
						  }, animationTime, function() {
						    // Animation complete.
							  
						  });
					  });
			});
    		//});
	};	

	Drupal.behaviors.homeTeaserVirtualMuseumScroll = function () {
		return true; //No animations for now
		var lastScrollTop = 0, delta = 5;
		$(window).scroll(function() {
			var elmentScrollPoint;
			var scrollTop = $(this).scrollTop();
			var scrollBottom = scrollTop + $(window).height();

			$(".homeTeaserVirtualMuseum").each(function (index){
				//Get center position
				var mainContent = $(this);
				var elementHeight = $(mainContent).height();
				var scrollPositionOfElement = $(mainContent).offset().top;
				var elementCenterPosition = scrollPositionOfElement + (elementHeight/2);
				var elementEndPosition = scrollPositionOfElement + elementHeight;
				
				if(Math.abs(lastScrollTop - scrollTop) <= delta){
					return true;
				}
			    var isDownDir;
				if (scrollTop > lastScrollTop){
					//downscroll code
					isDownDir = true;
				} else {
					//upscroll code
					isDownDir = false;
				}
				
				
				if(!isDownDir && scrollTop < elementCenterPosition && scrollBottom > elementEndPosition){
					Drupal.behaviors.animateHomeTeaserVirtualMuseumAboveToCenter(mainContent);
					$(mainContent).data("animation-type","AboveToCenter");				
				}else if (isDownDir && scrollTop > elementCenterPosition && scrollBottom > elementEndPosition){
					Drupal.behaviors.animateHomeTeaserVirtualMuseumCenterToAbove(mainContent);
					$(mainContent).data("animation-type","CenterToAbove");					
				}else if (isDownDir && scrollBottom > elementCenterPosition){
					Drupal.behaviors.animateHomeTeaserVirtualMuseumBelowToCenter(mainContent);
					$(mainContent).data("animation-type","BelowToCenter");
				}else if (!isDownDir && scrollBottom < elementCenterPosition){
					Drupal.behaviors.animateHomeTeaserVirtualMuseumCenterToBelow(mainContent);
					$(mainContent).data("animation-type","CenterToBelow");
				}
			});
			lastScrollTop = scrollTop;
		});
	}

})(jQuery);